<div fxLayout="row">
  <div fxFlex="80" style="height: 50px">
    <abc-drop-down-box
      #configCombobox
      [dataSource]="configGUIItems"
      (onValueChanged)="onConfigChanged($event)"
      [label]="res.get('AssetsConfiguration')"
      [height]="'auto'"
      [width]="'400px'"
      [visible]="true"
      [(value)]="configId"
      [displayExpr]="'name'"
      [valueExpr]="'id'"
      [isValid]="true"
      [gridColumns]="[{ dataField: 'name', caption: res.get('AssetsConfiguration') }]"
    >
    </abc-drop-down-box>
  </div>
  <div fxFlex="20" fxLayoutAlign="center center"></div>
</div>
<mat-checkbox class="example-margin" [(ngModel)]="checked" [disabled]="!usingStrang"
  >Bezeichnung mit Strängen</mat-checkbox
>
